import React from 'react';

import { useTranslation } from '../../../../hooks';
import { T } from '../../../../constants';

import "./style.scss";

interface PauseGameProps {
}

const PauseGame: React.FC<PauseGameProps> = () => {
  const t = useTranslation()
  return (
    <div className="pause-layer">
      <div className="pause-layout-in">
        <div className="pause-info">
          <span className="pause-title">{t(T.DEAR_PLAYER)}</span>
          <span className="pause-desc">{t(T.YOUR_GAME_IS_PAUSED)}</span>
        </div>
      </div>
    </div>
  );
};

export default PauseGame;
